import { z } from "@reflag/shared/utils/zod";

export const booleanish = z.preprocess((value) => {
  if (typeof value === "string") {
    return value === "true" || value === "1";
  }
  return Boolean(value);
}, z.boolean());
